var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 4.00001V3.46668C9.66667 2.71994 9.66667 2.34657 9.52134 2.06136C9.39351 1.81047 9.18954 1.6065 8.93865 1.47867C8.65344 1.33334 8.28007 1.33334 7.53333 1.33334H6.46667C5.71993 1.33334 5.34656 1.33334 5.06135 1.47867C4.81046 1.6065 4.60649 1.81047 4.47866 2.06136C4.33333 2.34657 4.33333 2.71994 4.33333 3.46668V4.00001M5.66667 7.66668V11M8.33333 7.66668V11M1 4.00001H13M11.6667 4.00001V11.4667C11.6667 12.5868 11.6667 13.1468 11.4487 13.5747C11.2569 13.951 10.951 14.2569 10.5746 14.4487C10.1468 14.6667 9.58677 14.6667 8.46667 14.6667H5.53333C4.41323 14.6667 3.85318 14.6667 3.42535 14.4487C3.04903 14.2569 2.74307 13.951 2.55132 13.5747C2.33333 13.1468 2.33333 12.5868 2.33333 11.4667V4.00001",
    stroke: "#207a87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashTeal);
export default __webpack_public_path__ + "static/media/trash-teal.e09fa1a3be142d4da26d643012271b67.svg";
export { ForwardRef as ReactComponent };